<template>
  <section class="jwb-module partner-slider">
    <div class="container">
      <h2 v-if="heading" class="tw-text-center">{{ heading }}</h2>
      <div class="the-slider">
        <div
          v-for="partner in sortedPartners"
          :key="partner.name"
          class="tw-block tw-mb-4"
        >
          <a v-if="partner.link" target="_blank" :href="partner.link">{{
            partner.name
          }}</a>
          <span v-else>{{ partner.name }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
import 'slick-carousel'

export default {
  props: {
    heading: {
      type: String,
      default: '',
    },
    partners: {
      type: String,
      default: '',
    },
  },
  computed: {
    sortedPartners() {
      return [...JSON.parse(this.partners)].sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      )
    },
  },
  mounted() {
    $('.jwb-module.partner-slider .the-slider').slick({
      mobileFirst: true,
      dots: true,
      rows: 3,
      slidesPerRow: 2,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            rows: 4,
            arrows: true,
            slidesPerRow: 3,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
  },
}
</script>
